/**
 * Surgeon Subset Template Types
 * 
 * Defines the structure for surgeon-specific authorization subsets
 * that represent clinically plausible ancillary procedures.
 */

export type PayerScopeType = 'all' | 'commercial' | 'workers_comp' | 'specific';

export interface SurgeonSubsetTemplate {
  id: string;
  surgeon_id: string;
  primary_cpt: string;
  subset_cpts: string[];
  payer_scope: PayerScopeType;
  specific_payer_id: string | null;
  is_active: boolean;
  version: number;
  superseded_by: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
  notes: string | null;
}

export interface SurgeonSubsetTemplateInsert {
  surgeon_id: string;
  primary_cpt: string;
  subset_cpts: string[];
  payer_scope: PayerScopeType;
  specific_payer_id?: string | null;
  is_active?: boolean;
  notes?: string | null;
}

export interface SurgeonSubsetTemplateUpdate {
  subset_cpts?: string[];
  payer_scope?: PayerScopeType;
  specific_payer_id?: string | null;
  is_active?: boolean;
  notes?: string | null;
}

// Joined type for UI display
export interface SurgeonSubsetTemplateWithDetails extends SurgeonSubsetTemplate {
  surgeon_name?: string;
  surgeon_email?: string;
  payer_name?: string;
  cpt_descriptions?: Record<string, string>;
}

// Form state for creating/editing subsets
export interface SubsetFormState {
  surgeon_id: string;
  primary_cpt: string;
  subset_cpts: string[];
  payer_scope: PayerScopeType;
  specific_payer_id: string | null;
  notes: string;
}

export const PAYER_SCOPE_LABELS: Record<PayerScopeType, string> = {
  all: 'All Payers',
  commercial: 'Commercial Only',
  workers_comp: "Workers' Comp Only",
  specific: 'Specific Payer',
};

export const initialSubsetFormState: SubsetFormState = {
  surgeon_id: '',
  primary_cpt: '',
  subset_cpts: [],
  payer_scope: 'all',
  specific_payer_id: null,
  notes: '',
};
